import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/components/layout'

const routes = [{
        path: '/',
        name: '预订助手',
        component: Layout,
        redirect: '/solution',
        showChildren: true,
        icon: "Aim",
        children: [{
                path: 'solution',
                name: '行程方案',
                icon: "Tickets",
                component: () =>
                    import ( /* webpackChunkName: "about" */ '@/views/solution.vue'),
            }, {
                path: 'command',
                name: '指令生成',
                icon: "Switch",
                component: () =>
                    import ( /* webpackChunkName: "about" */ '@/views/command.vue'),
            },
            // {
            //     path: 'home',
            //     name: '测试页',
            //     component: () =>
            //         import ( /* webpackChunkName: "about" */ '@/views/home.vue'),
            // }, {
            //     path: 'pageone',
            //     name: '页面1',
            //     component: () =>
            //         import ( /* webpackChunkName: "about" */ '@/views/test/PageOne.vue')
            // }
        ]
    },
    {
        path: '/contact',
        name: '联系作者',
        component: Layout,
        hidden: false,
        showChildren: false,
        redirect: '/contact',
        icon: "Cellphone",
        children: [{
            path: '',
            name: '联系作者',
            component: () =>
                import ( /* webpackChunkName: "about" */ '@/views/contact.vue')
        }]
    },
    {
        path: '/login',
        name: '登录',
        hidden: true,
        component: () =>
            import ( /* webpackChunkName: "about" */ '@/views/login')
    },
    {
        path: '/video',
        name: 'ETERM操作说明',
        hidden: true,
        component: () =>
            import ( /* webpackChunkName: "about" */ '@/views/video')
    },
    {
        path: '/videogds',
        name: '携程操作说明',
        hidden: true,
        component: () =>
            import ( /* webpackChunkName: "about" */ '@/views/videogds')
    },
    // {
    //     path: '/register',
    //     name: '用户注册',
    //     hidden: true,
    //     component: () =>
    //         import ( /* webpackChunkName: "about" */ '@/views/login/register')
    // },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router